import { useMemo } from 'react';
import qrcode from 'qrcode-generator';

/** A QR code drawn as one SVG path. Always dark on white, whatever the theme: scanners need the contrast. */
export function QrCode({ value, label }: { value: string; label: string }) {
  const { size, path } = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(value);
    qr.make();
    const count = qr.getModuleCount();
    let d = '';
    for (let row = 0; row < count; row++) {
      for (let col = 0; col < count; col++) {
        if (qr.isDark(row, col)) d += `M${col},${row}h1v1h-1z`;
      }
    }
    return { size: count, path: d };
  }, [value]);

  return (
    <svg
      role="img"
      aria-label={label}
      viewBox={`-3 -3 ${size + 6} ${size + 6}`}
      width={192}
      height={192}
      shapeRendering="crispEdges"
      className="rounded-md"
    >
      <rect x={-3} y={-3} width={size + 6} height={size + 6} fill="#ffffff" />
      <path d={path} fill="#000000" />
    </svg>
  );
}
